type VoucherCardProps = {
    title: string
    desc: string
    expired: string
    collected?: boolean
}

export default function VoucherCard({
    title,
    desc,
    expired,
    collected = false,
}: VoucherCardProps) {
    return (
        <div className="MuiGrid-root styles_coupon_card_grid__WyglQ MuiGrid-item" style={{ width: "100%" }}>
            <div className="styles_voucherTicket_container__ZVNbH MuiBox-root css-0">
                <div className="styles_voucherTicketMissingPart_topMarketplace__3x8Nx"></div>
                <div className="MuiGrid-root styles_voucherTicket_childContainerMarketplace__Qt15d MuiGrid-container">
                    <div className="MuiGrid-root styles_voucherTicket_leftContainer__HSp4p MuiGrid-item MuiGrid-grid-md-8">
                        <div className="MuiBox-root css-0">
                            <div className="styles_voucherTicket_nameMarketplace__KhCA_">{title}</div>
                        </div>
                        <div className="styles_content_2Line__6fSIC">{desc}</div>
                        <div className="MuiBox-root css-69i1ev">
                            <p className="MuiTypography-root styles_labelExpiredDate__qXiTb MuiTypography-body1">HSD: <span>{expired}</span></p>
                        </div>
                    </div>

                    <div className="styles_verticalDivider__mkts8" />

                    <div className="MuiGrid-root styles_buttonCollectWrapper__AOAJI MuiGrid-item MuiGrid-grid-md-4">
                        <div className="MuiBox-root css-0">
                            {collected ? (
                                <div className="MuiButtonBase-root MuiButton-root MuiButton-text styles_marketplaceButtonCollect__XWDy_">
                                    <span className="MuiButton-label">
                                        Đã thu thập
                                    </span>
                                </div>
                            ) : (
                                <div className="MuiBox-root css-icb29k"><span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, position: "relative", maxWidth: "100%" }}><span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0, maxWidth: "100%" }}><img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2714%27%20height=%2714%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: 0, margin: 0, padding: 0 }} /></span><img alt="voucher market collected" data-origin-url="https://cdn-web-next.thuocsi.vn/images/product-detail/collected_green_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/product-detail/collected_green_icon.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: 0, boxSizing: "border-box", padding: 0, border: "none", margin: "auto", display: "block", width: 0, height: 0, minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} /><noscript></noscript></span><span className="styles_textCollectedMarketplace___zjML">Đã thu thập</span></div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="styles_voucherTicketMissingPart_bottom__2ocE1"></div>
            </div>
        </div>
    )
}
